export default __webpack_public_path__ + "static/media/FACEBOOK_ADS.7ace89f1.jpg";